import React from "react";
import { compose, withState, defaultProps } from "recompose";
import { Input } from "antd";
import * as R from "ramda";
import { withTranslation } from "react-i18next";
import Fuse from "fuse.js";

import Element from "../structure/Element";

const Search = ({
  t,
  keys,
  children,
  criteria,
  data = [],
  setCriteria,
  initialValue
}) => (
  <>
    <Element marginBottom={12}>
      <Input.Search
        data-test="search"
        defaultValue={initialValue}
        placeholder={t("global:search")}
        onChange={e => setCriteria(e.target.value)}
      />
    </Element>
    {children(
      criteria
        ? new Fuse(data, {
            keys,
            threshold: 0.5,
            shouldSort: true
          }).search(criteria)
        : data
    )}
  </>
);

export default compose(
  withTranslation(["global"]),
  withState("criteria", "setCriteria", R.propOr("", "initialValue")),
  defaultProps({
    keys: ["name"]
  })
)(Search);
